import * as d3 from "d3";
import {
  removePointLabel,
  raisePointLabel,
  showLabel,
  showLabelMolecule,
} from "../RadarChart.functions";
import {SidebarTab} from "../../Sidebar";
import {ITypeRadar} from "../../../types";
// import {fetchTechnologyData} from "../../../helper";
// import {apiKeyDataTehnology, urlApiDataTehnology} from "../../../helper/api";
import {ClusterPoint} from "../../../pages/Dashboard/Dashboard.type";

interface ClusterPointProps {
  cluster: any;
  xStart: number;
  yStart: number;
  xMoleculaTwo: number;
  yMoleculaTwo: number;
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  segmentColor: {back: string; color: string};
  innerColor: {back: string; color: string};
  isActiveCluster: boolean;
  showAllLabels: boolean;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean,
    clusterIdNumber?: number
  ) => void;
  typeRadar: ITypeRadar;
  sectionName: string;
  setFocusPosition: (position: {x: number; y: number}) => void;
  isWeak_signal?: boolean;
  scale: number;
  hideLabel: () => void;
  activeTehnologyId: number | string | null | undefined;
}

const renderClusterPointMolecule = ({
  cluster,
  xStart,
  yStart,
  xMoleculaTwo,
  yMoleculaTwo,
  mainGroup,
  segmentColor,
  innerColor,
  isActiveCluster,
  showAllLabels,
  openSidebarWithTab,
  typeRadar,
  sectionName,
  setFocusPosition,
  isWeak_signal,
  scale,
  hideLabel,
  activeTehnologyId,
}: ClusterPointProps) => {
  const clusterPoint = mainGroup.append("g");
  const hoverColor = segmentColor;
  const deltaSizeDotOuter = typeRadar === "molecula" ? 10 : 2;

  const circleRadius = Math.min(
    Math.max(4, cluster.size * deltaSizeDotOuter),
    8
  );

  let typeOpenCard: SidebarTab;
  switch (typeRadar) {
    case "map":
      typeOpenCard = SidebarTab.CPU;
      break;
    case "esg":
      typeOpenCard = SidebarTab.Projects;
      break;
    case "fintech":
      if (!isWeak_signal) {
        typeOpenCard = SidebarTab.Trends;
      } else {
        typeOpenCard = SidebarTab.WeakSignal;
      }
      break;
    case "stateInitiative":
      typeOpenCard = SidebarTab.StateInitiative;
      break;
    default:
      typeOpenCard = SidebarTab.CPU;
  }

  const line = () =>
    clusterPoint
      .append("line")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", xStart)
      .attr("y2", yStart)
      .attr("stroke", "white")
      .attr("opacity", 0.5)
      .attr("stroke-width", 0.5);

  const lineLeft = () =>
    clusterPoint
      .append("path")
      .attr("d", function () {
        const startX = 0;
        const startY = 0;
        const endX = xStart;
        const endY = yStart;
        const radius =
          Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)) /
          0.1;
        return `M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY}`;
      })
      .attr("stroke", "white")
      .attr("opacity", 0.5)
      .attr("stroke-width", 0.5)
      .attr("fill", "none");

  const lineRight = () =>
    clusterPoint
      .append("path")
      .attr("d", function () {
        const startX = 0;
        const startY = 0;
        const endX = xStart;
        const endY = yStart;
        const radius =
          Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)) /
          0.1;
        return `M ${startX} ${startY} A ${radius} ${radius} 0 0 0 ${endX} ${endY}`;
      })
      .attr("stroke", "white")
      .attr("opacity", 0.5)
      .attr("stroke-width", 0.5)
      .attr("fill", "none");
  if (cluster.connection && cluster.connection === 1) {
    line();
  }
  if (cluster.connection && cluster.connection === 2) {
    lineLeft();
    lineRight();
  }
  if (cluster.connection && cluster.connection === 3) {
    lineLeft();
    line();
    lineRight();
  }

  const fontSizeMolecule = 8;
  const numCircles = 2;
  const radius = 25;
  const angle2 = Math.atan2(yStart, xStart);
  // const clusterView = async () => {
  // const clusterFetch = await getTechnologyData(cluster.id.toString());
  const clusterFetch = cluster;
  const tehnologies = clusterFetch?.tehnologies;
  if (tehnologies !== undefined && tehnologies.length > 0) {
    const cutTehnologies = tehnologies.slice(0, 8);
    for (let i = 0; i < cutTehnologies?.length; i++) {
      const angle = (i * 2 * Math.PI) / 4 / numCircles;
      let numAngle: number = (cutTehnologies.length - 1) * 0.4;
      const xN = xStart + radius * Math.cos(angle + angle2 - numAngle);
      const yN = yStart + radius * Math.sin(angle + angle2 - numAngle);

      const xLabel = xStart + 30 * Math.cos(angle + angle2 - numAngle);
      const yLabel = yStart + 30 * Math.sin(angle + angle2 - numAngle);

      const techData = async () => {
        const hideLabelTechnology = (
          isActiveTehnology = false,
          id?: number | string,
          activeTehnologyId?: number | string
        ) => {
          if (isActiveTehnology) return;
          if (id !== undefined) {
            removePointLabel(mainGroup, id, "technology");
          }
        };

        const isActiveTehnology =
          activeTehnologyId === cutTehnologies?.[i].documentId;
        const techId = tehnologies?.[i].documentId
          ? tehnologies?.[i].documentId
          : 0;
        const techName = tehnologies?.[i].documentId
          ? String(tehnologies?.[i].name)
          : "";

        const showHoverTechnologyLabel = () => {
          removePointLabel(mainGroup, techId, "technology");
          showLabelMolecule(
            techName,
            xN,
            yN,
            mainGroup,
            techId,
            "technology",
            innerColor,
            showAllLabels,
            typeRadar,
            undefined,
            fontSizeMolecule,
            true,
            false,
            true,
            xLabel,
            yLabel
          );
          raisePointLabel(mainGroup, techId, "technology");
        };

        const showActiveTechnologyLabel = () => {
          removePointLabel(mainGroup, techId, "technology");
          showLabelMolecule(
            techName,
            xN,
            yN,
            mainGroup,
            techId,
            "technology",
            innerColor,
            showAllLabels,
            typeRadar,
            scale,
            fontSizeMolecule,
            true,
            true,
            true,
            xLabel,
            yLabel
          );
          raisePointLabel(mainGroup, techId, "technology");
        };

        clusterPoint
          .append("line")
          .attr("x1", xStart)
          .attr("y1", yStart)
          .attr("x2", xN)
          .attr("y2", yN)
          .attr("stroke", "white")
          .attr("stroke-width", 0.5);
        clusterPoint
          .append("circle")
          .attr("id", `outcircle-${cluster.id}-${i}`)
          .attr("cx", xN)
          .attr("cy", yN)
          .attr("r", 4)
          .style("fill", innerColor.back)
          .style("stroke", "none")
          .style("opacity", 0.8)
          .style("cursor", "pointer")
          .on("mouseover", function () {
            d3.select(this.parentElement)
              .select(`#outline-inner-circle-${cluster.id}`)
              .style("opacity", 0);
            showHoverTechnologyLabel();
          })
          .on("click", () => {
            openSidebarWithTab(
              SidebarTab.CPU,
              cluster.direction_id as number,
              cluster.id,
              cluster.name,
              sectionName,
              innerColor,
              tehnologies?.[i].documentId ? String(tehnologies?.[i].name) : "",
              tehnologies?.[i].documentId
                ? String(tehnologies?.[i].documentId)
                : 0,
              "molecula",
              false,
              cluster.idNumber
            );
            if (xN && yN) setFocusPosition({x: xN, y: yN});
          })
          .on("mouseout", function () {
            if (isActiveTehnology) {
              showActiveTechnologyLabel();
              return;
            }
            hideLabelTechnology(
              false,
              tehnologies?.[i].documentId,
              activeTehnologyId ?? undefined
            );
          });
        if (showAllLabels && !isActiveTehnology) {
          showLabelMolecule(
            techName,
            xN,
            yN,
            mainGroup,
            Number(techId),
            "technology",
            innerColor,
            showAllLabels,
            typeRadar,
            scale,
            fontSizeMolecule,
            false,
            true,
            true,
            xLabel,
            yLabel
          );
        }

        if (isActiveTehnology) {
          showActiveTechnologyLabel();
        }
      };
      techData();
    }
  }
  clusterPoint
    .append("circle")
    .attr("cx", xStart)
    .attr("id", `outline-circle-${cluster.id}`)
    .attr("cy", yStart)
    .attr("r", circleRadius)
    .style("fill", segmentColor.back)
    .attr("opacity", 0.5)
    .style("stroke", "none")
    .on("mouseover", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 1);
    })
    .on("mouseout", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);
    });

  clusterPoint
    .append("circle")
    .attr("id", `outline-inner-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", 6)
    .style("fill", "#fff")
    .style("stroke", "none")
    .style("opacity", 0)
    .on("mouseover", function () {
      d3.select(this).style("opacity", 1);
      d3.select(this.parentElement)
        .select(`#outline-circle-${cluster.id}`)
        .style("fill", hoverColor.back);

      d3.select(this).style("border-radius", "1px");

      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
    })
    .on("mouseout", function () {
      d3.select(this).style("opacity", 0);

      if (!showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id as number,
          activeTehnologyId ?? undefined
        );
      }
      if (showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id as number,
          activeTehnologyId ?? undefined
        );
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
    });
  clusterPoint
    .append("circle")
    .attr("id", `inline-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", 5)
    .style("fill", innerColor.back)
    .style("stroke", "none")
    .style("stroke-width", 0.5)
    .style("cursor", "pointer")
    .on("mouseover", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 1);

      if (isActiveCluster && !activeTehnologyId) return;

      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
    })
    .on("mouseout", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);

      if (!showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id as number,
          activeTehnologyId ?? undefined
        );
      }
      if (showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id as number,
          activeTehnologyId ?? undefined
        );
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo
        );
      }
    })
    .on("click", () => {
      openSidebarWithTab(
        typeOpenCard,
        cluster.direction_id as number,
        cluster.id,
        cluster.name,
        sectionName,
        innerColor,
        undefined,
        undefined,
        typeRadar
      );
      if (xStart && yStart) setFocusPosition({x: xStart, y: yStart});
    });

  const hideLabelCluster = (
    isActiveCluster = false,
    id: number,
    activeTehnologyId?: number | string
  ) => {
    if (isActiveCluster && !activeTehnologyId) return;
    mainGroup.selectAll(`.tooltip-background-cluster${id}`).remove();
    mainGroup.selectAll(`.tooltip-text-cluster${id}`).remove();
  };

  if (showAllLabels && !isActiveCluster) {
    showLabel(
      cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      false,
      false,
      true,
      xMoleculaTwo,
      yMoleculaTwo
    );
  }
  if (isActiveCluster) {
    showLabel(
      cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      !activeTehnologyId ? true : false,
      false,
      true,
      xMoleculaTwo,
      yMoleculaTwo
    );
  }

  return null;
};

export default renderClusterPointMolecule;
